import React, { Component } from "react";
import { Row, Col, Button, Tabs, Tab, Modal, Spinner } from "react-bootstrap";
import "./style.css";
import { Bar } from "react-chartjs-2";
import { KeyboardDatePicker } from "@material-ui/pickers";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Checkbox from "@material-ui/core/Checkbox";
import { getInfoFinanceiraEstabelecimento } from "../../providers/EstabelecimentoProvider";
import RelatorioVenda from "../Relatorios/RelatorioVenda/relatorioVenda";
import RelatorioEntrega from "../Relatorios/RelatorioEntregas/relatorioEntregas";
import { getPedidosByDateRange } from "../../providers/PedidoProvider";

export default class Grafico extends Component {
  constructor(props) {
    super(props);
    this.state = {
      coresVendas: [],
      coresPreco: [],
      pedidos: [],
      dataInicio: null,
      dataFim: null,
      faturamento: {},
      taxa_operacao: 0,
      datas: [],
      pedido_grafico: [],
      vendas_dia: [],
      total_dia: [],
      metodo_dinheiro: false,
      metodo_debito: false,
      metodo_credito: false,
      telaRelatorio: false,
      key: "RelatorioVenda",
      ticketMedio: 0,
      modalShow: false,
    };
  }
  componentDidMount = async () => {
    const pedidos = [];
    const financeiro = await getInfoFinanceiraEstabelecimento();
    if (financeiro) {
      this.setState({ pedidos, taxa_operacao: financeiro.taxa_operacao });
    }
    this.alterarCoresGrafico();
  };
  alterarCoresGrafico() {
    const dataAtual = new Date();
    let coresVendas = [];
    let coresPreco = [];
    for (let i = 0; i < 7; i++) {
      if (i === dataAtual.getDay()) {
        coresVendas[i] = "#ffa500";
        coresPreco[i] = "#573ab7";
      } else {
        coresVendas[i] = "#EEFF01";
        coresPreco[i] = "#701B8C";
      }
    }
    this.setState({ coresVendas: coresVendas, coresPreco: coresPreco });
  }
  calcularValorPromo = (pedido) => {
    let total_promo = 0;
    pedido.itens.forEach((i) => {
      if (i.item && i.item.preco && i.item.preco.preco_encarte) {
        total_promo += i.item ? i.item.preco.preco_encarte * i.quantidade : 0;
      }
    });
    return total_promo;
  };

  handleRelatorio = (value) => {
    this.setState({ telaRelatorio: value });
  };

  formatFaturamento = (p, faturamento) => {
    const { taxa_operacao } = this.state;
    faturamento.total_vendas += 1;
    faturamento.total_faturado += p.detalhes_pagamento.subtotal;
    faturamento.total_promocoes += this.calcularValorPromo(p);
    if (p.detalhes_pagamento.subtotal >= faturamento.maior_venda) {
      faturamento.maior_venda = p.detalhes_pagamento.subtotal;
    }
    if (p.detalhes_pagamento.subtotal <= faturamento.menor_venda) {
      faturamento.menor_venda = p.detalhes_pagamento.subtotal;
    }
    if (
      p.detalhes_pagamento.frete &&
      p.metodo_pagamento.metodo === "pagamento_na_entrega"
    ) {
      faturamento.total_fretes += p.detalhes_pagamento.frete;
      faturamento.quantidade_fretes += 1;
    }
    if (p.metodo_pagamento.tipo === "dinheiro") {
      faturamento.total_fretes_dinheiro += p.detalhes_pagamento.frete;
      faturamento.quantidade_fretes_dinheiro += 1;
    } else {
      faturamento.total_fretes_cartao += p.detalhes_pagamento.frete;
      faturamento.quantidade_fretes_cartao += 1;
    }

    faturamento.total_estabelecimento = faturamento.total_faturado * (1 - taxa_operacao);
    faturamento.total_ifeira = faturamento.total_faturado * taxa_operacao;
    return faturamento;
  };

  calcularFaturamento = async (dataInicio, dataFim) => {
    this.setState({ modalShow: true });
    const pedidos = await getPedidosByDateRange(dataInicio, dataFim);
    const { metodo_credito, metodo_debito, metodo_dinheiro } = this.state;
    let faturamento = {
      total_faturado: 0,
      total_vendas: 0,
      total_fretes: 0,
      total_estabelecimento: 0,
      total_ifeira: 0,
      maior_venda: 0,
      menor_venda: 999999999999,
      total_promocoes: 0,
      pedidos_cancelados: 0,
      quantidade_fretes: 0,
      fretes_ifeira: 0,
      total_fretes_cartao: 0,
      total_fretes_dinheiro: 0,
      quantidade_fretes_cartao: 0,
      quantidade_fretes_dinheiro: 0,
    };
    const datas = [];
    let mapPedido = new Map();
    let mapVendas = new Map();
    let somaSubtotais = 0;
    const now = new Date();
    let diaDaSemana = now.getDay();
    let inicioDaSemana = new Date(now.getTime() - diaDaSemana * (1000 * 3600 * 24));
    let fimDaSemana = new Date(inicioDaSemana.getTime() + 6 * 1000 * 3600 * 24);
    if (!(dataInicio && dataFim)) {
      for (let i = 0; i < 7; i++) {
        datas.push(new Date(inicioDaSemana.getTime() + i * 1000 * 3600 * 24));
        mapPedido[datas[i].getDate() + "/" + (datas[i].getMonth() + 1)] = 0;
        mapVendas[datas[i].getDate() + "/" + (datas[i].getMonth() + 1)] = 0;
      }
    }
    pedidos.forEach((p) => {
      const date = p.agendado ? new Date(p.dataAgendamento) : new Date(p.createdAt);
      if (p.status === "entregue" || p.status === "entrega_finalizada") {
        somaSubtotais = parseFloat(p.detalhes_pagamento.subtotal) + somaSubtotais;
        if (dataInicio && dataFim) {
          const dataInicioF = new Date(dataInicio);
          const dataFimF = new Date(dataFim);
          dataInicioF.setUTCHours(0);
          dataFimF.setUTCHours(23);
          if (
            dataInicioF.getTime() <= date.getTime() &&
            dataFimF.getTime() >= date.getTime()
          ) {
            datas.push(date);
            if (mapPedido[date.getDate() + "/" + (date.getMonth() + 1)] > 0) {
              mapPedido[date.getDate() + "/" + (date.getMonth() + 1)] +=
                p.detalhes_pagamento.subtotal;
            } else {
              mapPedido[date.getDate() + "/" + (date.getMonth() + 1)] = parseFloat(
                p.detalhes_pagamento.subtotal.toFixed(2),
              );
            }
            if (mapVendas[date.getDate() + "/" + (date.getMonth() + 1)] > 0) {
              mapVendas[date.getDate() + "/" + (date.getMonth() + 1)] += 1;
            } else {
              mapVendas[date.getDate() + "/" + (date.getMonth() + 1)] = 1;
            }

            faturamento = this.formatFaturamento(p, faturamento);
            if (p.status === "cancelado") {
              faturamento.pedidos_cancelados += 1;
            }
          }
        } else if (inicioDaSemana <= date && fimDaSemana >= date) {
          if (metodo_dinheiro && metodo_credito) {
            if (p.metodo_pagamento.tipo !== "debito") {
              faturamento = this.formatFaturamento(p, faturamento);
            }
          } else if (metodo_dinheiro && metodo_debito) {
            if (p.metodo_pagamento.tipo !== "credito") {
              faturamento = this.formatFaturamento(p, faturamento);
            }
          } else if (metodo_debito && metodo_credito) {
            if (p.metodo_pagamento.tipo !== "dinheiro") {
              faturamento = this.formatFaturamento(p, faturamento);
            }
          } else if (metodo_dinheiro && !metodo_credito && !metodo_debito) {
            if (
              p.metodo_pagamento.tipo !== "debito" &&
              p.metodo_pagamento.tipo !== "credito"
            ) {
              faturamento = this.formatFaturamento(p, faturamento);
            }
          } else if (!metodo_dinheiro && !metodo_debito && metodo_credito) {
            if (
              p.metodo_pagamento.tipo !== "dinheiro" &&
              p.metodo_pagamento.tipo !== "debito"
            ) {
              faturamento = this.formatFaturamento(p, faturamento);
            }
          } else if (metodo_debito && !metodo_credito && !metodo_dinheiro) {
            if (
              p.metodo_pagamento.tipo !== "dinheiro" &&
              p.metodo_pagamento.tipo !== "credito"
            ) {
              faturamento = this.formatFaturamento(p, faturamento);
            }
          } else {
            faturamento = this.formatFaturamento(p, faturamento);
          }
          if (mapPedido[date.getDate() + "/" + (date.getMonth() + 1)] > 0) {
            mapPedido[date.getDate() + "/" + (date.getMonth() + 1)] +=
              p.detalhes_pagamento.subtotal;
          } else {
            mapPedido[date.getDate() + "/" + (date.getMonth() + 1)] = parseFloat(
              p.detalhes_pagamento.subtotal.toFixed(2),
            );
          }
          if (mapVendas[date.getDate() + "/" + (date.getMonth() + 1)] > 0) {
            mapVendas[date.getDate() + "/" + (date.getMonth() + 1)] += 1;
          } else {
            mapVendas[date.getDate() + "/" + (date.getMonth() + 1)] = 1;
          }
        } else {
          faturamento = this.formatFaturamento(p, faturamento);
          if (p.status === "cancelado") {
            faturamento.pedidos_cancelados += 1;
          }
        }
      }
    });
    let ticketMedio = (faturamento.total_faturado / faturamento.total_vendas)
      .toFixed(2)
      .toString()
      .replace(".", ",");
    let vendas_dia = Object.keys(mapVendas).map((k) => mapVendas[k]);
    let pedido_grafico = Object.keys(mapPedido).map((k) =>
      parseFloat(parseFloat(mapPedido[k]).toFixed(2).replace(".", ",")),
    );
    faturamento.menor_venda =
      faturamento.menor_venda === 999999999999 ? 0 : faturamento.menor_venda;
    Object.keys(faturamento).forEach(
      (k) => (faturamento[k] = parseFloat(faturamento[k]).toFixed(2).replace(".", ",")),
    );
    this.setState({
      faturamento,
      ticketMedio,
      datas: [...new Set(datas.map((d) => d.getDate() + "/" + (d.getMonth() + 1)))],
      pedido_grafico,
      vendas_dia,
      modalShow: false,
    });
  };

  limparDados = () => {
    this.setState({
      faturamento: {},
      ticketMedio: null,
      datas: [],
      pedido_grafico: [],
      vendas_dia: null,
      modalShow: false,
      dataInicio: null,
      dataFim: null,
    });
  };

  render() {
    const { faturamento, dataInicio, dataFim } = this.state;
    return (
      <div>
        {this.state.telaRelatorio === false ? (
          <div>
            <Row md={12}>
              <Col md={6}>
                <h3>Relatório de vendas</h3>
                <br></br>
                <Row>
                  <Col>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <p style={{ marginBottom: 0, fontWeight: "bold" }}>
                        Defina um período de vendas:{" "}
                      </p>

                      {/* <div className="alert-periodo">
                      <p>Periodo Total</p>
                    </div> */}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "flex-end",
                        }}
                      >
                        <p style={{ marginRight: 30 }}>De</p>
                        <KeyboardDatePicker
                          disableToolbar
                          variant="inline"
                          margin="normal"
                          id="Data de início"
                          label="Data inicial"
                          value={this.state.dataInicio}
                          style={{ width: "60%" }}
                          maxDate={new Date()}
                          onChange={(d) => this.setState({ dataInicio: d })}
                        />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "flex-end",
                        }}
                      >
                        <p style={{ marginRight: 30 }}>Até</p>
                        <KeyboardDatePicker
                          disableToolbar
                          disabled={!this.state.dataInicio}
                          variant="inline"
                          margin="normal"
                          id="date-picker-inline"
                          label="Data final"
                          minDate={this.state.dataInicio}
                          maxDate={new Date()}
                          value={this.state.dataFim}
                          style={{ width: "60%" }}
                          onChange={(d) => this.setState({ dataFim: d })}
                        />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          marginTop: 17,
                        }}
                      >
                        <Button
                          style={{ height: 35 }}
                          onClick={() => this.calcularFaturamento(dataInicio, dataFim)}
                        >
                          Aplicar
                        </Button>
                        {dataInicio && dataFim ? (
                          <Button
                            variant="danger"
                            style={{ height: 35, marginLeft: 5 }}
                            onClick={() => {
                              this.limparDados();
                            }}
                          >
                            Limpar
                          </Button>
                        ) : null}
                      </div>
                    </div>
                  </Col>
                </Row>
                <br></br>
                <div style={{ maxHeight: 520, overflow: "auto" }}>
                  <Card style={{ width: "90%" }}>
                    <CardContent>
                      <p className="card-label">
                        Total de vendas:{" "}
                        <span className="card-value">{faturamento.total_vendas}</span>
                      </p>
                      <p className="card-label">
                        Total faturado:{" "}
                        <span className="card-value">
                          R$ {faturamento.total_faturado}
                        </span>
                      </p>
                      <p className="card-label">
                        Total faturado em fretes:{" "}
                        <span className="card-value">R$ {faturamento.total_fretes}</span>
                      </p>
                    </CardContent>
                  </Card>
                  <br></br>
                  <Card style={{ width: "90%" }}>
                    <p className="card-title">Faturamento</p>
                    <CardContent>
                      <p className="card-label">
                        Estabelecimento:{" "}
                        <span className="card-value">
                          R$ {faturamento.total_estabelecimento}
                        </span>
                      </p>
                      <p className="card-label">
                        iFeira:{" "}
                        <span className="card-value">R$ {faturamento.total_ifeira}</span>
                      </p>
                      <p className="card-label">
                        Frete:{" "}
                        <span className="card-value">R$ {faturamento.total_fretes}</span>
                      </p>
                    </CardContent>
                  </Card>
                  <br></br>
                  <Card style={{ width: "90%" }}>
                    <p className="card-title">Venda</p>
                    <CardContent>
                      <p className="card-label">
                        Ticket médio:{" "}
                        <span className="card-value">R$ {this.state.ticketMedio}</span>
                      </p>
                      <p className="card-label">
                        Maior venda:{" "}
                        <span className="card-value">R$ {faturamento.maior_venda}</span>
                      </p>
                      <p className="card-label">
                        Menor venda:{" "}
                        <span className="card-value">R$ {faturamento.menor_venda}</span>
                      </p>
                      <p className="card-label">
                        Faturamento com promoções:{" "}
                        <span className="card-value">
                          R$ {faturamento.total_promocoes}
                        </span>
                      </p>
                      <p className="card-label">
                        Pedidos cancelados:{" "}
                        <span className="card-value">
                          {faturamento.pedidos_cancelados}
                        </span>
                      </p>
                    </CardContent>
                  </Card>
                  <br></br>
                  <Card style={{ width: "90%" }}>
                    <p className="card-title">Frete</p>
                    <CardContent>
                      <p className="card-label">
                        Valor total:{" "}
                        <span className="card-value">R$ {faturamento.total_fretes}</span>
                      </p>
                      <p className="card-label">
                        Quantidade total:{" "}
                        <span className="card-value">
                          {faturamento.quantidade_fretes}
                        </span>
                      </p>
                      <p className="card-label">
                        Valor total - dinheiro:{" "}
                        <span className="card-value">
                          R$ {faturamento.total_fretes_dinheiro}
                        </span>
                      </p>
                      <p className="card-label">
                        Quantidade total - dinheiro:{" "}
                        <span className="card-value">
                          {faturamento.quantidade_fretes_dinheiro}
                        </span>
                      </p>
                      <p className="card-label">
                        Valor total - cartão:{" "}
                        <span className="card-value">
                          R$ {faturamento.total_fretes_cartao}
                        </span>
                      </p>
                      <p className="card-label">
                        Quantidade total - cartão:{" "}
                        <span className="card-value">
                          {faturamento.quantidade_fretes_cartao}
                        </span>
                      </p>
                      {/* <p className="card-label">Valor recebido pelo iFeira: </p> */}
                    </CardContent>
                  </Card>
                  {/* <Card style={{ width: '90%' }}>
                  <p className="card-title">Entregas por Bairro</p>
                    <CardContent>
                      <p className="card-label">Total de vendas: </p>
                      <p className="card-label">Total faturado: </p>
                      <p className="card-label">Total faturado em fretes: </p>
                    </CardContent>
                  </Card> */}
                  <br></br>
                </div>
              </Col>
              <Col md={6}>
                <h3>Gráfico semanal</h3>
                <br></br>
                {this.state.pedido_grafico ? (
                  <div>
                    <div style={{ width: "50%", float: "left" }}>
                      <Bar
                        data={{
                          labels: this.state.datas,
                          datasets: [
                            {
                              type: "bar",
                              label: "Total Vendas",
                              fill: false,
                              borderColor: "#701B8C",
                              backgroundColor: this.state.coresVendas,
                              borderWidth: 1,
                              hoverBorderColor: "#ffffff",
                              data: this.state.vendas_dia,
                            },
                          ],
                        }}
                        options={{
                          scales: {
                            yAxes: [
                              {
                                ticks: {
                                  beginAtZero: true,
                                  min: 0,
                                  stepSize: 10,
                                },
                              },
                            ],
                          },
                        }}
                        height={300}
                      />
                    </div>
                    <div style={{ width: "50%", float: "right" }}>
                      <Bar
                        data={{
                          labels: this.state.datas,
                          datasets: [
                            {
                              type: "bar",
                              backgroundColor: this.state.coresPreco,
                              borderColor: "#EEFF01",
                              borderWidth: 1,
                              hoverBorderColor: "#ffffff",
                              label: "Total R$",
                              data: this.state.pedido_grafico,
                            },
                          ],
                        }}
                        options={{
                          scales: {
                            yAxes: [
                              {
                                ticks: {
                                  beginAtZero: true,
                                  min: 0,
                                },
                              },
                            ],
                          },
                        }}
                        height={300}
                      />
                    </div>
                  </div>
                ) : null}
                <p className="card-label" style={{ clear: "both" }}>
                  Filtrar por
                </p>
                <p className="card-label">Método de pagamento</p>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <div className="ckeckbox">
                    <Checkbox
                      value={this.state.metodo_dinheiro}
                      onChange={(e) =>
                        this.setState({ metodo_dinheiro: e.target.checked })
                      }
                      color="primary"
                    />
                    <span className="checkbox-label">Dinheiro</span>
                  </div>
                  <div className="ckeckbox">
                    <Checkbox
                      value={this.state.metodo_credito}
                      onChange={(e) =>
                        this.setState({ metodo_credito: e.target.checked })
                      }
                      color="primary"
                    />
                    <span className="checkbox-label">Crédito</span>
                  </div>
                  <div className="ckeckbox">
                    <Checkbox
                      value={this.state.metodo_debito}
                      onChange={(e) => this.setState({ metodo_debito: e.target.checked })}
                      color="primary"
                    />
                    <span className="checkbox-label">Débito</span>
                  </div>
                  <Button
                    style={{ height: 35 }}
                    onClick={() => this.calcularFaturamento(dataInicio, dataFim)}
                  >
                    Aplicar
                  </Button>
                </div>
                <br></br>
                <Button
                  variant="outline-primary"
                  style={{ height: 35 }}
                  onClick={() => this.handleRelatorio(true)}
                >
                  Visualizar Relatórios Detalhados
                </Button>
              </Col>
            </Row>
          </div>
        ) : (
          <div>
            <Row style={{ paddingLeft: 20 }}>
              <Button
                variant="outline-primary"
                style={{ height: 35, marginRight: 20 }}
                onClick={() => this.handleRelatorio(false)}
              >
                Voltar
              </Button>
              <h3>Relatório Geral</h3>
            </Row>
            <br />
            <br />
            <Tabs
              id="controlled-tab-example"
              className="tabStyle"
              activeKey={this.state.key}
              onSelect={(key) => this.setState({ key })}
            >
              <Tab eventKey="RelatorioVenda" title="Relatório Venda a Venda">
                <RelatorioVenda ticketMedio={this.state.ticketMedio} />
              </Tab>
              <Tab eventKey="RelatorioEntrega" title="Relatório de Entregas">
                <RelatorioEntrega />
              </Tab>
            </Tabs>
          </div>
        )}
        <Modal
          show={this.state.modalShow}
          backdrop="static"
          keyboard={false}
          size="sm"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Body>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
              Carregando...
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
